const forEachBadge = (callback) => {
	document.querySelectorAll('[data-offer-like-count]').forEach(callback);
};

const updateOfferLikeCount = (count) => {
	forEachBadge((badge) => {
		badge.textContent = String(count);
	});
};

export const shiftOfferLikeCount = (delta) => {
	forEachBadge((badge) => {
		badge.textContent = String(Number(badge.textContent) + delta);
	});
};

export default (naja) => {
	naja.addEventListener('success', (event) => {
		const count = event.detail.payload?.offerLikeCount;
		if (count === undefined) {
			return;
		}

		updateOfferLikeCount(count);
	});
};
